import { render, staticRenderFns } from "./HuellaCarbonoGeneral.vue?vue&type=template&id=461be561&scoped=true&"
import script from "./HuellaCarbonoGeneral.vue?vue&type=script&lang=ts&"
export * from "./HuellaCarbonoGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461be561",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('461be561', component.options)
    } else {
      api.reload('461be561', component.options)
    }
    module.hot.accept("./HuellaCarbonoGeneral.vue?vue&type=template&id=461be561&scoped=true&", function () {
      api.rerender('461be561', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/HuellaCarbono/HuellaCarbonoGeneral.vue"
export default component.exports